<template>
  <div id="app" style="height:100%;">
    <!--<img src="./assets/logo.png">-->
    <router-view></router-view>
    <customerService></customerService>
  </div>
</template>

<script>
import customerService from '@/components/common/customerService'
export default {
  name: 'app',
  components: { customerService }
}
</script>

<style>
.pdfContainer {
  padding: 5px;
  margin: 5px;
  cursor: pointer;
  border: 1px solid rgb(238, 238, 238);
  display: inline-block;
}

.pdfContainer:hover {
  border: 1px solid #108cee;
}

.el-transfer-panel {
  width: 360px !important;
  min-height: 600px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue